"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useId, useState } from "react";
import { BRAND_ASSETS } from "@/lib/brand-assets";
import { COMPANY } from "@/lib/company";

const NAV = [
  { href: "/services", label: "Services" },
  { href: "/approach", label: "Our approach" },
  { href: "/privacy", label: "Privacy" },
] as const;

export function SiteHeader() {
  const pathname = usePathname();
  const [open, setOpen] = useState(false);
  const [navPath, setNavPath] = useState(pathname);
  const navId = useId();

  // Close the mobile menu when the route changes (e.g. back/forward).
  if (navPath !== pathname) {
    setNavPath(pathname);
    if (open) setOpen(false);
  }

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to main content
      </a>
      <section className="utility" aria-label="Phone and email">
        <div className="wrap">
          <a href={`tel:${COMPANY.phone}`}>{COMPANY.phoneDisplay}</a>
          <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
        </div>
      </section>
      <header className="site-header">
        <div className="wrap nav">
          <Link className="brand" href="/" aria-label={`${COMPANY.name} home`}>
            <Image
              src={BRAND_ASSETS.mark}
              alt=""
              width={55}
              height={55}
              className="brand-mark"
              priority
            />
            <span className="brand-copy">
              <b>{COMPANY.name}</b>
              <small>Asbestos surveys</small>
            </span>
          </Link>

          <button
            type="button"
            className="menu-button"
            aria-expanded={open}
            aria-controls={navId}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? "Close" : "Menu"}
          </button>

          <nav
            id={navId}
            className={`nav-links${open ? " open" : ""}`}
            aria-label="Primary"
          >
            {NAV.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                aria-current={pathname === item.href ? "page" : undefined}
                onClick={() => setOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            <Link
              className="btn btn-primary nav-cta"
              href="/contact"
              aria-current={pathname === "/contact" ? "page" : undefined}
              onClick={() => setOpen(false)}
            >
              Request a survey
            </Link>
          </nav>
        </div>
      </header>
    </>
  );
}
